import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useClient } from 'jsonapi-react';
import moment from 'moment';
import { FiClock } from 'react-icons/fi';
import { EmptyState } from '@/components/custom/empty-state';
import { Loader } from '@/components/custom/loader';
import { PlayfulCard, PlayfulCardButton } from '@/components/custom/playful-card';
import liveScreenIcon from '@/assets/images/icons/live-screen.png';

export default function LiveClassesHighlights() {
  const client = useClient();
  const navigate = useNavigate();
  const [liveClasses, setLiveClasses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchTodayLiveClasses = async () => {
      setLoading(true);
      try {
        const today = moment().format('YYYY-MM-DD');
        const { data } = await client.fetch(`/live_classrooms?filter[date_between][initial]=${today}&filter[date_between][final]=${today}`);
        const now = moment();
        setLiveClasses((data || []).filter(item => now.isBetween(item['initial-date'], item['end-date'])));
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    };

    fetchTodayLiveClasses();
  }, []);

  if (loading) {
    return <Loader />;
  }

  if (liveClasses.length === 0) {
    return (
      <EmptyState
        type="data"
        title="Nenhuma aula ao vivo no momento"
        variant="plain"
        className="pt-32"
      />
    );
  }

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
      {liveClasses.map(liveClass => (
        <PlayfulCard
          key={liveClass.id}
          badge={{ text: 'Ao vivo', variant: 'red' }}
          className="p-5"
          onClick={() => navigate(`/aulas-ao-vivo/${liveClass.id}`)}
        >
          <img
            src={liveScreenIcon}
            alt=""
            className="h-20 w-20 object-contain"
          />

          <h3 className="mb-0 mt-3 line-clamp-3 text-base font-extrabold text-neutral-900">{liveClass.title}</h3>
          {liveClass.courses?.[0]?.name && <p className="mb-0 mt-0.5 text-sm text-neutral-dark">{liveClass.courses[0].name}</p>}

          <div className="mt-auto flex flex-col gap-3 pt-2">
            <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 text-xs font-semibold text-neutral-dark">
              <span className="flex items-center gap-1.5">
                <FiClock className="h-3.5 w-3.5 text-mission" />
                {`${moment(liveClass['initial-date']).format('H[h]')} às ${moment(liveClass['end-date']).format('H[h]')}`}
              </span>
            </div>

            <PlayfulCardButton onClick={() => navigate(`/aulas-ao-vivo/${liveClass.id}`)}>Acessar</PlayfulCardButton>
          </div>
        </PlayfulCard>
      ))}
    </div>
  );
}
